/** Marketing-site legal pages. Both live on the same page behind anchors. */
export const TERMS_URL = 'https://www.bazaart.com/terms/#page'
export const PRIVACY_POLICY_URL = 'https://www.bazaart.com/terms/#privacy'
